import React, {FC} from 'react'

type Props = {
  stripeId?: string
}

const UserStripeIdCell: FC<Props> = ({stripeId}: Props) => {
  return <div className='badge badge-light fw-bolder'>{stripeId}</div>
}

export default UserStripeIdCell
